export enum TaskDialogEnum {
  /**Если выйти сейчас, введенные данные не сохранятся */
  ExitWithoutSaving = 'exit-without-saving',
  /**Введенные данные будут изменены */
  DataWillBeOverwritten = 'data-will-be-overwritten',
  /**Импортированные данные будут сброшены */
  ImportedDataWillBeReset = 'imported-data-will-be-reset',
  /**Отмена изменений в описании */
  CancelDescriptionChanges = 'cancel-description-changes',
}
